export const ACCEPT_HEADER = `Accept`;
export const CONTENT_TYPE_HEADER = `Content-Type`;
export const CONTENT_TYPE_JSON = `application/json`;
export const CONTENT_TYPE_GQL = `application/graphql-response+json`;
export const statusCodes = {
    success: 200,
};
//# sourceMappingURL=http.js.map